import React from 'react'
import './Icons.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';




import i1 from '../../img/logo-preview-1.png';
import i2 from '../../img/logo-preview-2.png';
import i3 from '../../img/logo-preview-3.png';
import i4 from '../../img/logo-preview-4.png';
import i5 from '../../img/logo-preview-5.png';
import i6 from '../../img/logo-preview-6.png';
import i7 from '../../img/logo-preview-7.png';
import i8 from '../../img/logo-preview-8.png';
// import i9 from '../../img/logo-preview-9.png';
import i10 from '../../img/logo-preview-10.png';

export default function Icons() {
    const iconItems = [
        { img: i1 },
        { img: i2 },
        { img: i3 },
        { img: i4 },
        { img: i5 },
        { img: i6 },
        { img: i7 },
        { img: i8 },
        { img: i10 },
      ];
  return (
    <div>
      <section className="horizontal-icons-section">
        <Swiper
          spaceBetween={10}
          slidesPerView={8}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          modules={[Autoplay]}
          loop={true}
        >
          {iconItems.map((item, index) => (
            <SwiperSlide key={index} className="icon-item">
              <img src={item.img} alt={item.label} />
             
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <hr />
    </div>
  )
}
